/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Understanding_DescInputs */

const en_directory_agent_readiness_understanding_desc = /** @type {(inputs: Directory_Agent_Readiness_Understanding_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How well an agent can figure out what this product is and how to start using it — official docs, quickstart, examples.`)
};

const zh_directory_agent_readiness_understanding_desc = /** @type {(inputs: Directory_Agent_Readiness_Understanding_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 能否弄清这个产品是什么、如何上手——官方文档、快速开始、示例。`)
};

/**
* | output |
* | --- |
* | "How well an agent can figure out what this product is and how to start using it — official docs, quickstart, examples." |
*
* @param {Directory_Agent_Readiness_Understanding_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_understanding_desc = /** @type {((inputs?: Directory_Agent_Readiness_Understanding_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Understanding_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_understanding_desc(inputs)
	return zh_directory_agent_readiness_understanding_desc(inputs)
});
export { directory_agent_readiness_understanding_desc as "directory.agent_readiness.understanding_desc" }